import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import { useTranslation } from 'react-i18next';
import * as Interface from '@Redux/detail/Group/interfaces';
import { RootState } from '@Redux/detail/store';
import {
    setCalendarGuaranteedChecked,
    setCalendarParmIsEnsureGroup,
} from '@Redux/detail/Group/actions';
import { Checkbox } from '@lion-design/core';
import styles from './styles.module.scss';

const GroupAllGuaranteed: React.FC<Interface.I_GroupAllModeswitcher> = () => {
    const { t } = useTranslation();
    const { CalendarGroups, Schedules, GroupInfo } = useSelector(
        (state: RootState) => state.groupReducer
    );

    const dispatch = useDispatch();

    const checkboxProps = {
        onChange: (active: boolean) => {
            dispatch(setCalendarGuaranteedChecked(active));
            dispatch(setCalendarParmIsEnsureGroup(active));
        },
        checked: CalendarGroups.isGuaranteedChecked,
        title: `只找${t('IsEnsureGroup')}`,
        disabled: CalendarGroups.isGuaranteedDisabled,
        checkFillColor: '#669', //勾勾顏色
        checkedBackgroundColor: 'transparent', //勾起來的時候的背景色
    };

    return (
        <div className={cN(styles['group_all_guaranteed'], 'group_all_guaranteed')}>
            <Checkbox {...checkboxProps} />
        </div>
    );
};

export default GroupAllGuaranteed;
